import('./bootstrap')

// This satisfied --isolatedModules (tsconfig)
export {}
